export const sampleData = {
  columns: [
    { field: "COLORCODE", headerName: "Color Code", width: 120 },
    { field: "NAME", headerName: "Name", width: 200 },

    { field: "EMAIL", headerName: "Email", width: 200 },
    {
      field: "CONTACTNO",
      headerName: "Contact Number",
      width: 200,
      // textAlign: "CENTER",
    },
    {
      field: "DATE",
      headerName: "Schedule Date",
      width: 200,
      // textAlign: "CENTER",
    },
    { field: "TIME", headerName: "Start Time", width: 200 },
    {
      field: "AMOUNT",
      headerName: "Amount",
      width: 200,
      textAlign: "right",
      textTransform: "capitalize",
    },

    // Add more column definitions as needed
  ],
  rows: [
    {
      field: 1,
      COLORCODE: "#FFFFE0",
      NAME: "Roberto Carlos",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
    {
      field: 2,
      COLORCODE: "#F8FFE0",
      NAME: "Roberto Carlos",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
    {
      field: 3,
      COLORCODE: "#ADFF2F",
      NAME: "John Doe 2",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
    {
      field: 4,
      COLORCODE: "#000",
      NAME: "John Doe 2",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
    // Add more rows as needed
  ],

  name: "Sample Details",
};

export const brandData = {
  columns: [
    { field: "brandname", headerName: "Brand Name", width: 120, flex: 1 },
    { field: "descrip", headerName: "Description", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Brand Details",
};

export const Catergorydata = {
  columns: [
    { field: "catname", headerName: "Category Name", width: 120, flex: 1 },
    // { field: "colorcode", headerName: "Color Code", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Category Details",
};

export const subCatergorydata = {
  columns: [
    {
      field: "subcatname",
      headerName: "Subcategory name",
      width: 120,
      flex: 1,
    },
    { field: "catname", headerName: "Category Name", width: 120, flex: 1 },
    // { field: "colorcode", headerName: "color code", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Subcategory Details",
};

export const Doctypedata = {
  columns: [
    { field: "doctype", headerName: "Document Type Name ", width: 120, flex: 1 },
    // { field: "docsavecode", headerName: "Document Save Code", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Document Type Details",
};

export const Reasontypedata = {
  columns: [
    // { field: "doctype", headerName: "Document Type Name ", width: 120, flex: 1 },
    { field: "descrip", headerName: "Reason", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Reason Type Details",
};

export const Industrydata = {
  columns: [
    { field: "industryname", headerName: "industry Name", width: 120, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Industry Details",
};

export const Supchargedata = {
  columns: [
    { field: "supchargetype", headerName: "Supplier Charge Type", width: 120, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Supplier Charges",
};

export const chargedata = {
  columns: [
    { field: "chargetype", headerName: " Charge Type", width: 120, flex: 1 },

    // Add more column definitions as needed
  ],

  name: " Charges",
};

export const warehousedata = {
  columns: [
    { field: "restname", headerName: "Warehouse", width: 150, flex: 1 },
   
    // Add more column definitions as needed
  ],

  name: "Warehouse Details",
};

export const Bankdata = {
  columns: [
    { field: "bankname", headerName: "Bank Name", width: 120, flex: 1 },
      { field: "bankcode", headerName: "Bank Code", width: 120, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Bank Details",
};

export const Branchdata = {
  columns: [
    { field: "branchname", headerName: "Branch Name", width: 120, flex: 1 },
    { field: "branchcode", headerName: "Branch Code", width: 120, flex: 1 },
    // Add more column definitions as needed
  ],

  name: "Branch Details",
};

export const MOUdata = {
  columns: [
    {
      field: "immeasuringunit",
      headerName: "measuring Unit",
      width: 120,
      flex: 1,
    },
    { field: "descrip", headerName: "description", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Measuring Unit Details",
};

export const Packagedata = {
  columns: [
    { field: "packagename", headerName: "package name", width: 120, flex: 1 },
    { field: "descrip", headerName: "description", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Package Details",
};

export const Productdata = {
  columns: [
    { field: "productname", headerName: "product name", width: 120, flex: 1 },
    { field: "packagename", headerName: "package name", width: 120, flex: 1 },

    { field: "catname", headerName: "Category name", width: 200, flex: 1 },
    {
      field: "subcatname",
      headerName: " SubCategory name",
      width: 200,
      flex: 1,
    },
    { field: "brandname", headerName: "Brand name", width: 120, flex: 1 },
    {
      field: "minorderlevel",
      headerName: "Minimum Order Level",
      width: 200,
      flex: 1,
    },
    {
      field: "immeasuringunit",
      headerName: "measuring unit",
      width: 120,
      flex: 1,
    },
    { field: "descrip", headerName: "description", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Product Details",
};

export const advanceSearchData = {
  columns: [
    { field: "PONUMBER", headerName: "PO Number", flex: 1 },

    { field: "PODATE", headerName: "PO Date", flex: 1 },
    {
      field: "DELIVERYDATE",
      headerName: "Delivery Date",
      flex: 1,
      // textAlign: "CENTER",
    },
    {
      field: "DELIVERYLOCATION",
      headerName: "Delivery Location",
      flex: 1,
      // textAlign: "CENTER",
    },

    // Add more column definitions as needed
  ],
  rows: [
    {
      field: 1,
      PONUMBER: "PO00007",
      PODATE: "22/21/2025",
      DELIVERYDATE: "22/21/2025",
      DELIVERYLOCATION: "Colombo",
    },

    // Add more rows as needed
  ],

  name: "Sample Details",
};

export const grnPoSummary = {
  columns: [
    { field: "ITEMCODE", headerName: "Item Name", flex: 1 },

    { field: "ITEMNAME", headerName: "Item Name", flex: 1 },
    {
      field: "BRAND",
      headerName: "Brand",
      flex: 1,
      // textAlign: "CENTER",
    },
    {
      field: "UOM",
      headerName: "UOM",
      flex: 1,
      // textAlign: "CENTER",
    },

    {
      field: "POQUANTITY",
      headerName: "PO Quantity",
      flex: 1,
      // textAlign: "CENTER",
    },

    // Add more column definitions as needed
  ],
  rows: [
    {
      field: 1,
      ITEMCODE: "PO00007",
      ITEMNAME: "Kiri Samba",
      BRAND: "Araliya",
      UOM: "KG",

      POQUANTITY: "1000",
    },

    // Add more rows as needed
  ],

  name: "Sample Details",
};
